<template>
  <base-list-view
    @state-scroll="scrollList"
  >
    <div class="partner-list">
      <pre-loader v-if="isLoadingPrev"/>
      <template
        v-for="partner in partnerList"
        :key="partner.id"
      >
        <h2 v-if="partner.type === 'title'">
          {{ partner.name }}
        </h2>
        <div
          v-if="partner.type === 'partner'"
          :id="'partner-' + partner.id"
          :class="`partner-item item-size-${partner.size}`"
          @click="saveScrollContext(partner)"
          @keydown.enter="saveScrollContext(partner)"
        >
          <partner-card
            :photo="partner.logo"
            :partner-id="partner.id"
          />
        </div>
      </template>
      <system-card
        v-if="systemMessage"
        :system-message="systemMessage"
        :cbFunc="repeatGetPage"
      />
      <pre-loader v-if="isLoading && !isLoadingPrev"/>
    </div>
  </base-list-view>
</template>
<script>
import { DateTime } from 'luxon';
import appBaseNav from '@/components/mixins/appBaseNav';
import sponsors from '@/components/mixins/methodsSponsors';
import banners from '@/components/mixins/methodsBanners';
import listScrollMixin from '@/components/mixins/viewers/listScrollMixin';

import baseListView from '@/components/shared/baseListView.vue';
import SystemCard from '@/components/shared/upCard/SystemCard.vue';

// размер плитки для партнёра без категории — как у мелкой
const DEFAULT_CATEGORY_SIZE = 6;

export default {
  name: 'ListPartnersView',
  components: { baseListView, SystemCard },
  props: {
    launchDownload: {
      type: Boolean,
    },
    locale: {
      type: String,
    },
    page: {
      type: String,
      default: null,
    },
  },
  data() {
    const savedRaw = sessionStorage.getItem('partnerScrollCtx');
    const saved = savedRaw ? JSON.parse(savedRaw) : null;
    if (saved) sessionStorage.removeItem('partnerScrollCtx');
    const startPage = saved ? saved.firstPage : (parseInt(this.page, 10) || 1);
    return {
      partnerList: [],
      categoryList: null,
      isLoading: true,
      firstPage: startPage,
      curPage: startPage,
      countPage: null,

      itPriority: null,

      isLoadingPrev: false,
      isLastDownloaded: false,
      systemMessage: null,
      scrollTargetId: saved ? saved.targetId : null,
    };
  },
  mixins: [appBaseNav, sponsors, banners, listScrollMixin],
  watch: {
    locale() {
      this.$store.commit('setPageTitle', this.$t('partnerList.header_title'));
    },
  },
  mounted() {
    this.$store.commit('setPageTitle', this.$t('partnerList.header_title'));
    Promise.all([
      this.getBanner('sponsor', this.$store.getters.getBannerPartnerTs),
      this.getSponsorCategory(),
    ])
      .then(([
        banner,
        catgory,
      ]) => {
        this.isLoading = false;
        if (banner && Object.keys(banner).length) {
          this.$emit('showBanner', banner);
          const nowMilis = DateTime.now().toMillis();
          localStorage.setItem('bannerPartnerTs', nowMilis);
          this.$store.commit('setBannerPartnerTs', nowMilis);
        }

        const categories = Array.isArray(catgory) ? catgory : [];
        this.categoryList = new Map(categories.map((item) => ([item.id, { ...item }])));
        this.getPage();
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('ListPartnersView::mounted', error);
        this.isLoading = false;
        this.categoryList = new Map();
        this.systemMessage = this.$t('system.bad_connect');
      });
  },
  methods: {
    getPage() {
      if (this.countPage === null || this.curPage <= this.countPage) {
        this.isLoading = true;

        this.getSponsorList(this.curPage)
          .then((data) => {
            this.isLoading = false;
            this.$emit('turnOff', {
              stateDownload: false,
              stateCheckInbox: false,
            });
            if (data?.results && Array.isArray(data.results)) {
              const { items, endPriority } = this.presetPartnerList(data.results, this.itPriority);
              const tagged = items.map((i) => ({ ...i, sourcePage: data.page }));
              this.partnerList = [...this.partnerList, ...tagged];
              this.itPriority = endPriority;
              this.countPage = data.num_pages;
              this.curPage = data.page;
              this.isLastDownloaded = true;
              this.systemMessage = null;
              this.$nextTick(() => {
                const hadTarget = !!this.scrollTargetId;
                this.tryScrollToTarget();
                if (!hadTarget) this.checkScrollBoundaries();
              });
            } else {
              this.isLastDownloaded = false;
              this.systemMessage = this.$t('system.bad_connect');
            }
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('getPage()::', error);
          });
      } else {
        this.$emit('turnOff', {
          stateCheckInbox: true,
        });
      }
    },
    getPrevPage() {
      if (this.firstPage <= 1) return;

      const scrollEl = document.getElementById('content__wrapper');
      const listEl = document.getElementById('listView');

      const heightBeforeLoader = listEl.offsetHeight;
      const scrollBeforeLoader = scrollEl.scrollTop;

      this.isLoading = true;
      this.isLoadingPrev = true;

      this.$nextTick(() => {
        this.adjustScroll(scrollBeforeLoader, heightBeforeLoader);
      });

      this.getSponsorList(this.firstPage - 1)
        .then((data) => {
          if (data?.results && Array.isArray(data.results)) {
            const heightBeforeData = listEl.offsetHeight;
            const scrollBeforeData = scrollEl.scrollTop;

            const { items: rawPrepended } = this.presetPartnerList(data.results, null);
            const prepended = rawPrepended.map((i) => ({ ...i, sourcePage: data.page }));

            this.isLoading = false;
            this.isLoadingPrev = false;

            // убираем дублирующий заголовок на стыке страниц
            const lastPartner = [...prepended].reverse().find((i) => i.type === 'partner');
            const existingList = (lastPartner && this.partnerList[0]?.type === 'title' && this.partnerList[0]?.id === lastPartner.category_id)
              ? this.partnerList.slice(1)
              : this.partnerList;

            this.partnerList = [...prepended, ...existingList];
            this.firstPage -= 1;
            this.systemMessage = null;

            this.$nextTick(() => {
              this.adjustScroll(scrollBeforeData, heightBeforeData);
            });
          } else {
            this.isLoading = false;
            this.isLoadingPrev = false;
            this.systemMessage = this.$t('system.bad_connect');
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('getPrevPage()::', error);
          this.isLoading = false;
          this.isLoadingPrev = false;
        });
    },
    saveScrollContext(partner) {
      sessionStorage.setItem('partnerScrollCtx', JSON.stringify({
        targetId: `partner-${partner.id}`,
        firstPage: partner.sourcePage || 1,
      }));
    },
    tryScrollToTarget() {
      if (!this.scrollTargetId) return;
      const el = document.getElementById(this.scrollTargetId);
      if (el) {
        el.scrollIntoView({ block: 'center' });
        this.scrollTargetId = null;
      }
    },
    presetPartnerList(list, startPriority) {
      let priority = startPriority ?? null;
      const items = [];
      list.forEach((item) => {
        // категории может не быть: у партнёра бывает category_id === null,
        // либо категория отсутствует в справочнике. Раньше обращение к .size
        // у undefined бросало исключение и весь список оставался пустым
        const category = this.categoryList.get(item.category_id) || null;
        if (priority !== item.category_id) {
          priority = item.category_id;
          if (category) {
            items.push({
              ...category,
              type: 'title',
            });
          }
        }
        items.push({
          ...item,
          size: category ? category.size : DEFAULT_CATEGORY_SIZE,
          type: 'partner',
        });
      });
      return { items, endPriority: priority };
    },
  },
};
</script>
<style lang="scss">
.partner {
  &-list {
    display: flex;
    flex-wrap: wrap;
    // неполный ряд встаёт по центру, а не прижимается влево
    justify-content: center;
    gap: 12px;

    h2 {
      flex: 1 0 100%;
      text-align: center;
      margin: 0;
      padding: 12px 12px 0;
    }
  }
  &-list &-item {
    height: 160px;

    // ширина задана точно: при гибкой основе в ряд влезает лишняя плитка
    &.item-size-4 {
      flex: 0 0 calc(33.333% - 8px);
    }
    &.item-size-6 {
      flex: 1 1 40%;
      max-width: calc(50% - 6px);
    }
    &.item-size-12 {
      flex: 1 0 100%;
    }
    @media (min-width: 480px) {
      flex: 1 1 30%;
      max-width: calc(33.333% - 6px);

      &.item-size-4 {
        flex: 0 0 calc(16.666% - 10px);
      }
      &.item-size-6 {
        flex: 1 0 25%;
        max-width: calc(25% - 9px);
      }
      &.item-size-12 {
        flex: 1 0 100%;
        max-width: 100%;

        // отступ внутри карточки, а не вокруг неё: так края крупной плитки
        // совпадают с рядом мелких, а логотип остаётся прежней величины
        & .upCard {
          padding: 36px 12px;
        }
      }
    }

    & .upCard {
      padding: 12px;
      border-radius: 16px;
    }
  }
}
</style>
